import type { BackofficeTranslations } from './backoffice.interface';

export const backofficeTranslations: BackofficeTranslations = {
  nav_section_title: 'Console interno',
  nav_overview: 'Resumo',
  nav_organizations: 'Organizações',
  nav_users: 'Usuários',
  nav_cards_cases: 'Conciliação',
  nav_cards_calls: 'Chamadas ao provedor',

  error_generic: 'Não conseguimos concluir a ação.',
  retry: 'Tentar novamente',
  filters_label: 'Filtros',
  filters_clear: 'Limpar filtros',
  never: 'Nunca',
  actions_label: 'Ações',

  overview_title: 'Resumo',
  overview_subtitle: 'Como está o {{brand}} hoje, em todas as organizações.',
  kpi_organizations: 'Organizações',
  kpi_users: 'Usuários clientes',
  kpi_internal_users: 'Usuários internos',
  kpi_signups_7: 'Cadastros · 7 dias',
  kpi_signups_30: 'Cadastros · 30 dias',
  subscriptions_title: 'Assinaturas por status',
  subscriptions_empty: 'Ainda não há assinaturas.',
  generated_at: 'Calculado em {{date}}',
  analytics_soon_badge: 'Em breve',
  analytics_soon_title: 'Analítica de produto',
  analytics_soon_description:
    'Funis, retenção e uso por organização, do PostHog. Esta tela é a base para conectá-los.',

  subscription_status_active: 'Ativa',
  subscription_status_trialing: 'Em teste',
  subscription_status_past_due: 'Pagamento pendente',
  subscription_status_cancelled: 'Cancelada',

  status_active: 'Ativa',
  status_disabled: 'Desativada',

  orgs_title: 'Organizações',
  orgs_subtitle: 'Todas as organizações do {{brand}}.',
  orgs_search_placeholder: 'Buscar pelo e-mail ou nome de um membro',
  filter_status_label: 'Status',
  filter_status_all: 'Todos os status',
  col_owner: 'Titular',
  col_status: 'Status',
  col_members: 'Membros',
  col_subscription: 'Assinatura',
  col_created: 'Criada',
  no_subscription: 'Sem assinatura',
  owner_unknown: 'Sem membros',
  orgs_empty_title: 'Nenhuma organização',
  orgs_empty_description: 'Tente outra busca ou limpe os filtros.',

  org_detail_title: 'Organização',
  org_members_title: 'Membros',
  org_field_id: 'ID',
  org_field_created: 'Criada',
  org_field_status: 'Status',
  org_field_plan: 'Plano',
  org_field_period_end: 'Fim do período',
  org_field_trial_end: 'Fim do teste',
  org_field_members: 'Membros',

  users_title: 'Usuários',
  users_subtitle: 'Todas as contas do {{brand}}, clientes e internas.',
  users_search_placeholder: 'Buscar por e-mail ou nome',
  filter_type_label: 'Tipo',
  filter_type_all: 'Todos os tipos',
  type_user: 'Cliente',
  type_internal_user: 'Interno',
  col_user: 'Usuário',
  col_type: 'Tipo',
  col_organization: 'Organização',
  col_last_login: 'Último acesso',
  users_empty_title: 'Nenhum usuário',
  users_empty_description: 'Tente outra busca ou limpe os filtros.',

  action_impersonate: 'Entrar como este usuário',
  action_promote: 'Tornar interno',
  action_view_organization: 'Ver organização',

  impersonate_title: 'Entrar como {{email}}',
  impersonate_description:
    'Este link abre uma sessão na conta do cliente. Funciona uma única vez e fica registrado quem o abriu.',
  impersonate_link_label: 'Link de acesso',
  impersonate_copy: 'Copiar link',
  impersonate_copied: 'Copiado',
  impersonate_expires: 'Expira às {{time}}.',
  impersonate_private_hint:
    'Abra em uma janela anônima: nesta janela ele substituiria sua sessão interna.',
  impersonate_close: 'Fechar',

  promote_title: 'Tornar {{email}} interno?',
  promote_description:
    'A pessoa sai da organização, todas as sessões são encerradas e no próximo acesso verá este console. Não dá para desfazer por aqui.',
  promote_confirm: 'Tornar interno',
  promote_cancel: 'Cancelar',
  promote_success: 'Agora é um usuário interno.',

  error_LAST_ACTIVE_MEMBER:
    'É o único membro ativo da organização, que ficaria sem ninguém para entrar. Crie uma nova conta interna.',
  error_ALREADY_INTERNAL: 'Esta conta já é interna.',
  error_USER_INACTIVE: 'A conta está desativada.',
  error_TARGET_NOT_CUSTOMER: 'Só é possível entrar em contas de clientes.',

  cases_title: 'Conciliação',
  cases_subtitle: 'Diferenças entre o nosso livro e o provedor que alguém precisa revisar.',
  filter_case_status_label: 'Status',
  filter_case_status_all: 'Todos os status',
  case_status_open: 'Aberto',
  case_status_investigating: 'Em análise',
  case_status_resolved: 'Resolvido',
  case_status_dismissed: 'Descartado',
  case_kind_balance_mismatch: 'Saldo divergente',
  case_kind_negative_balance: 'Saldo negativo',
  case_kind_transfer_stuck: 'Transferência travada',
  case_kind_unknown_event: 'Evento desconhecido',
  case_kind_provider_account_missing: 'Conta ausente no provedor',
  case_kind_provider_deleted: 'Excluída no provedor',
  col_case_kind: 'Tipo',
  col_case_status: 'Status',
  col_case_organization: 'Organização',
  col_case_residual: 'Diferença',
  col_case_runs: 'Execuções',
  col_case_hold: 'Retenção',
  col_case_created: 'Aberto',
  hold_yes: 'Congelada',
  hold_no: 'Sem retenção',
  cases_empty_title: 'Sem casos',
  cases_empty_description: 'Não há diferenças pendentes com estes filtros.',
  action_investigate: 'Marcar em análise',
  action_resolve: 'Resolver',
  investigate_success: 'Caso marcado em análise.',
  resolve_title: 'Resolver caso',
  resolve_description:
    'A conciliação roda de novo antes de fechar: se a diferença ainda for grave, o caso continua aberto.',
  resolve_type_label: 'Resolução',
  resolve_type_dismiss: 'Descartar (não era uma diferença real)',
  resolve_type_provider_corrected: 'O provedor corrigiu',
  resolve_note_label: 'Nota',
  resolve_note_placeholder: 'O que você encontrou e por que fecha',
  resolve_restore_label: 'Reativar cartões',
  resolve_restore_description: 'Descongela os cartões que estavam ativos antes da retenção.',
  resolve_confirm: 'Resolver',
  resolve_cancel: 'Cancelar',
  resolve_success: 'Caso resolvido.',

  calls_title: 'Chamadas ao provedor',
  calls_subtitle: 'Auditoria de cada chamada ao provedor de cartões, sem dados sensíveis.',
  calls_operation_placeholder: 'Operação, ex. accounts.batchTransfer',
  filter_outcome_label: 'Resultado',
  filter_outcome_all: 'Todos os resultados',
  outcome_ok: 'OK',
  outcome_error: 'Erro',
  col_call_operation: 'Operação',
  col_call_outcome: 'Resultado',
  col_call_organization: 'Organização',
  col_call_targets: 'Recursos',
  col_call_created: 'Data',
  calls_empty_title: 'Sem chamadas',
  calls_empty_description: 'Não há chamadas com estes filtros.',
};
